import { palette } from './tokens/palette'

/** Status colors for the dashboard (main page) — distinct from device/catalog statuses. */
export const dashboardStatusColors = {
    online: palette.success.main,
    offline: palette.neutral[700],
    sleep: palette.neutral[850],
    error: palette.error.main,
    scoreboardOnline: palette.brandBlue[700],
} as const
